import * as Notifications from 'expo-notifications';

export const ORDER_FEEDBACK_NOTIFICATIONS_CHANNEL_ID = 'orders-feedback-channel';

export const ORDER_FEEDBACK_NOTIFICATION_ANDROID_VISIBILITY_PUBLIC =
  Notifications.AndroidNotificationVisibility.PUBLIC;

export const ORDER_FEEDBACK_NOTIFICATION_ANDROID_IMPORTANCE = Notifications.AndroidImportance.MAX;

export const ORDER_FEEDBACK_NOTIFICATION_ANDROID_COLOR = '#00473C'; // should be hex color
